import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { Clear as ClearIcon, Search as SearchIcon } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";

/**
 * Search box for the Nalsar case lists.
 * onSearchChange fires `debounce` ms after the user stops typing, and at once on clear.
 */
export default function SearchCases({
  value = "",
  onSearchChange,
  placeholder = "Search Cases...",
  debounce = 400,
}) {
  const [text, setText] = useState(value);
  const timerRef = useRef(null);

  useEffect(() => {
    setText(value);
  }, [value]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleChange = (e) => {
    const val = e.target.value;
    setText(val);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onSearchChange(val), debounce);
  };

  const handleClear = () => {
    setText("");
    clearTimeout(timerRef.current);
    onSearchChange("");
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      placeholder={placeholder}
      value={text}
      onChange={handleChange}
      style={{ minWidth: 260, backgroundColor: "#fff", borderRadius: "4px" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: text ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              aria-label="Clear search"
              onClick={handleClear}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
        style: { fontSize: "0.875rem" },
      }}
    />
  );
}
